import {actions as A} from '../constants/actions';

const defaultState = {
  showErrorMessage: false,
  message: '',
};

export default (state = defaultState, {type, payload}) => {
  switch(type) {
    case A.SHOW_GLOBAL_ERROR_MESSAGE:
    case A.GET_TRANSLATIONS_FAILURE:
    case A.GET_NEXT_STEP_FAILURE:
    case A.UPLOAD_FILE_FAILURE:
    case A.UPLOAD_ID_FILE_FAILURE:
    case A.CHECK_AGENT_ID_FAILURE:
    case A.CHECK_ID_NUMBER_FAILURE:
      const {message} = payload;
      return {...state, showErrorMessage: true, message};

    case A.HIDE_GLOBAL_ERROR_MESSAGE:
      return {...state, showErrorMessage: false};

    default:
      return state;
  }
}
